// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zkHu","selected":"styles_selected__3lyJa"};